import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './Gateway.module.scss';

export const GatewayStepOneSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepSection_1}>The Gateway</div>
        <div className={styles.stepSection_2}>to</div>
        <div className={styles.stepSection_3}>the Future</div>
      </div>
    }
    rightContent={
      <div className={styles.stepContent}>
        <div>
          The world is changing before our eyes. TransparenTerra strives to establish and improve
          environmental, social, and economic harmony.
        </div>
        <div>
          TransparenTerra brings together people, projects, and companies to make the world a better
          place, openly and honestly, by demonstrating their core values. We believe that
          enthusiasts, good deeds, and aspirations will shape a better future.
        </div>
      </div>
    }
  />
);
